// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container .modal-container,
.app-container .loading-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  backdrop-filter: blur(2px);
  background-color: rgba(173, 173, 173, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
}
.app-container .loading-container {
  z-index: 10001;
}
.app-container .toast {
  position: absolute;
  top: 60px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACE;;EAEE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,0BAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,kBAAA;EACA,SAAA;AAFJ","sourcesContent":[".app-container {\n  .modal-container,\n  .loading-container {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    backdrop-filter: blur(2px);\n    background-color: rgba(173, 173, 173, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10001;\n  }\n\n  .loading-container {\n    z-index: 10001;\n  }\n\n  .toast {\n    position: absolute;\n    top: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
